var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import client from "@irati/utils/services/apollo";
import { userMetadataQuery, getUserAuditQuery, privateUserMetadataQuery } from "./queries";
import updateUserMetadataMutation from "./mutation/updateUserMetadata";
import updatePrivateUserMetadataMutation from "./mutation/updatePrivateUserMetadata";
var UserMetadataService = /** @class */ (function () {
    function UserMetadataService() {
    }
    UserMetadataService.prototype.get = function (userId, options) {
        if (options === void 0) { options = {}; }
        return client
            .query(__assign(__assign({}, options), { query: userMetadataQuery, variables: {
                userId: userId
            } }))
            .then(function (_a) {
            var data = _a.data;
            return data.userMetadata;
        })
            .catch(function (err) { return console.log(err); });
    };
    UserMetadataService.prototype.getPrivateMetadata = function (userId, options) {
        if (options === void 0) { options = {}; }
        return client
            .query(__assign(__assign({}, options), { query: privateUserMetadataQuery, variables: {
                userId: userId
            } }))
            .then(function (_a) {
            var data = _a.data;
            return data.userMetadata;
        })
            .catch(function (err) { return console.log(err); });
    };
    UserMetadataService.prototype.update = function (uuid, userMetadata, options) {
        if (options === void 0) { options = {}; }
        userMetadata.uuid = uuid;
        return client
            .mutate(__assign(__assign({}, options), { mutation: updateUserMetadataMutation, variables: { userMetadata: userMetadata } }))
            .then(function (res) { return res.data; })
            .catch(function (err) { return console.log(err); });
    };
    UserMetadataService.prototype.getUserAudit = function (userId, action, limit, page, options) {
        if (options === void 0) { options = {}; }
        return client
            .query(__assign(__assign({}, options), { query: getUserAuditQuery, variables: {
                userId: userId,
                action: action,
                limit: limit,
                page: page
            } }))
            .then(function (_a) {
            var data = _a.data;
            return data.userAudit;
        });
    };
    UserMetadataService.prototype.updatePrivateMetadata = function (uuid, userMetadata, options) {
        if (options === void 0) { options = {}; }
        userMetadata.uuid = uuid;
        delete userMetadata.config.favouriteCategories;
        return client
            .mutate(__assign(__assign({}, options), { mutation: updatePrivateUserMetadataMutation, variables: { userMetadata: userMetadata } }))
            .then(function (res) { return res.data.updateUserMetadata; })
            .catch(function (err) { return console.log(err); });
    };
    return UserMetadataService;
}());
var service = new UserMetadataService();
export var getUserMetadata = service.get;
export var updateUserMetadata = service.update;
export var getPrivateUserMetadata = service.getPrivateMetadata;
export var updatePrivateUserMetadata = service.updatePrivateMetadata;
export var getUserAudit = service.getUserAudit;
export default service;
